export default __webpack_public_path__ + "images/DK.27b6cba.png";